import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import RecommendContainer from '@board/containers/RecommendContainer.vue'

@Component({
    components: { PageViewHeaderWithActionBar, RecommendContainer },
})
export default class RecommendView extends Vue {
}